import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import { forwardRef, createElement } from 'react';
import { mergeClasses, toKebabCase } from './shared/src/utils.js';
import Icon from './Icon.js';
var createLucideIcon = function createLucideIcon(iconName, iconNode) {
  var Component = forwardRef(function (_ref, ref) {
    var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);
    return createElement(Icon, _objectSpread({
      ref: ref,
      iconNode: iconNode,
      className: mergeClasses("lucide-".concat(toKebabCase(iconName)), className)
    }, props));
  });
  Component.displayName = "".concat(iconName);
  return Component;
};
export { createLucideIcon as default };